<script setup>
import { storeToRefs } from 'pinia';
import Button from 'primevue/button';
import { excluirPareceres } from '@/api/fetchParecer';
import { useCriarParecerParaEstudantesStore } from '@/store/criarParecerParaEstudantesStore';
const store = useCriarParecerParaEstudantesStore();
const {pareceres} = storeToRefs(store);
const props = defineProps({
    idPareceres: Array
})

async function excluir(){
    let resultado = await excluirPareceres(props.idPareceres);
    if (resultado) {
        pareceres.value = [];
    }
}
</script>

<template>
    <Button label="Excluir Pareceres" icon="pi pi-trash" severity="danger" class="hidden lg:block" @click="excluir" />

</template>